/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary).
 */

// ============================================================
// MOQ (Minimum Order Quantity) Enforcement
// Reads data-moq attribute set in Liquid on quantity inputs
// and enforces the minimum on PDP, cart page, and mini-cart.
// ============================================================

document.addEventListener('DOMContentLoaded', function () {

  // ----------------------------------------------------------
  // 1. CART PAGE + MINI-CART — Decrease button (capture phase)
  //    Fires BEFORE the theme's own click handler so we can
  //    stop the event entirely when already at MOQ.
  // ----------------------------------------------------------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action="decrease-quantity"]');
    if (!btn) return;

    var moq = parseInt(btn.getAttribute('data-moq'));
    if (!moq || isNaN(moq)) return;

    var selector = btn.closest('.quantity-selector');
    if (!selector) return;

    var input = selector.querySelector('.quantity-selector__value');
    if (!input) return;

    var currentVal = parseInt(input.value);
    if (currentVal <= moq) {
      // Already at or below MOQ — block everything, no flash
      e.stopImmediatePropagation();
      e.preventDefault();
      return false;
    }
  }, true); // true = capture phase, runs before theme handler


  // ----------------------------------------------------------
  // 2. CART PAGE + MINI-CART — Direct input edit
  //    Clamps typed values back to MOQ on change.
  // ----------------------------------------------------------
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.classList.contains('quantity-selector__value')) return;

    var moq = parseInt(input.getAttribute('data-moq'));
    if (!moq || isNaN(moq)) return;

    // Only clamp for cart selectors (not the PDP quantity-picker)
    if (input.closest('quantity-picker')) return;

    if (parseInt(input.value) < moq) {
      input.value = moq;
      // Re-dispatch so theme re-renders cart with corrected value
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });


  // ----------------------------------------------------------
  // 3. PDP — Decrease button inside quantity-picker element
  //    Fires BEFORE the QuantityPicker custom element handler.
  // ----------------------------------------------------------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action="decrease-picker-quantity"]');
    if (!btn) return;

    var picker = btn.closest('quantity-picker');
    if (!picker) return;

    var input = picker.querySelector('.quantity-selector__value');
    if (!input) return;

    var moq = parseInt(input.getAttribute('data-moq'));
    if (!moq || isNaN(moq)) return;

    var currentVal = parseInt(input.value);
    if (currentVal <= moq) {
      // Block the decrease — stay at MOQ, no flash
      e.stopImmediatePropagation();
      e.preventDefault();
      return false;
    }
  }, true); // capture phase


  // ----------------------------------------------------------
  // 4. PDP — Direct input edit inside quantity-picker
  //    Clamps typed values back to MOQ on change.
  // ----------------------------------------------------------
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.classList.contains('quantity-selector__value')) return;
    if (!input.closest('quantity-picker')) return;

    var moq = parseInt(input.getAttribute('data-moq'));
    if (!moq || isNaN(moq)) return;

    if (parseInt(input.value) < moq) {
      input.value = moq;
    }
  });

});